interface CircleProps {
    size?: string;
    bg?: string;
    value: string;
    border?: boolean;
    text?: string;
    handlerAction?: () => {
        return;
    } | void;
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function CircleComponent(props: CircleProps): JSX.Element {
    const { size, bg, border, text, value, handlerAction } = props;
    //size 1- 10 11 12 + 4 max 96
    return (
        <div
            className={`flex ${size} ${bg} mt-4 rounded-full text-center justify-center content-center ${
                border ? ' border-2 border-black' : ''
            } ${handlerAction ? 'cursor-pointer' : ''}`}
            onClick={() => {
                handlerAction && handlerAction();
            }}
        >
            <div className={`flex items-center ${text} text-white`}>{value}</div>
        </div>
    );
}
